import { AffiliateApi } from "@/api/affiliates";
import { PayAffiliatePaymentRequest } from "@/api/affiliates/types";
import { useMutation } from "@tanstack/react-query";
import { useNotify } from "react-admin";
import { useUIStore } from "@/stores";
import { queryClient, QueryKey } from "@/utils";

export const usePayAffiliatePayment = () => {
  const notify = useNotify();
  const { closeModal } = useUIStore();

  const { mutate: payAffiliatePayment, isPending } = useMutation({
    mutationFn: (body: PayAffiliatePaymentRequest) =>
      AffiliateApi.payAffiliatePayment(body),
    onError: (error) => {
      setTimeout(() => {
        notify(error, { type: "error" });
      }, 250);
    },
    onSuccess: (_, { affiliateId }) => {
      closeModal();
      queryClient.invalidateQueries({
        queryKey: [QueryKey.AFFILIATE_PAYOUTS, affiliateId],
      });
      setTimeout(() => {
        notify("Affiliate payment has been successfully processed!", {
          type: "success",
        });
      }, 250);
    },
  });

  return {
    payAffiliatePayment,
    isProcessingAffiliatePayment: isPending,
  };
};
